import React, { useEffect, useState } from 'react';
import { Table, Button, Input, Space, DatePicker, Select, Checkbox, Pagination } from 'antd';
import { ClockCircleOutlined, UploadOutlined } from "@ant-design/icons";
import moment from 'moment';
import { useHistory } from "react-router-dom";
import { downlaod_pdf, getAllData, getAllDataParams, getAllDataParamsColumns, get_AuditView, get_employee_listing_not_Terminated } from '../../../Services/employee'; // Assuming these are your API functions
import roleManager from '../../../Components/roles';
import { seriliazeParams } from '../../../helpers/seriliazeParams';
import { exportAuditTab } from '../../../Services/LocomotiveServices';
import { Loader } from '@progress/kendo-react-all';
import { CircularProgress } from '@mui/material';
const AuditTab = () => {
  const history = useHistory();
  const [AuditTabData, setAuditTabData] = useState({ header: [], rows: [] });
  const [filteredData, setFilteredData] = useState(AuditTabData.rows);
  const [filterOptions, setFilterOptions] = useState({
    location: [],
    subDepartment: [],
  });
  const [EmployeeListData, setEmployeeListData] = useState([])
  const [auditData, setAuditData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    id: '',
    createdAt: '',
    Location_Id: '',
    SubDepartmentID: '',
    ForemanSupId: '',
    TemplateUsed: '',
    EvaluatorId: null,

  });

  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const handleChange = (pagination, Filters, sorter) => {
    // Logging for debugging
    console.log("Pagination:", pagination);
    console.log("Filters:", filteredInfo);
    console.log("Sorter:", sorter);
    Object.keys(Filters)?.forEach((key) => {
      if (!Filters[key]) delete Filters[key]
    })
    console.log(Filters, 'hassan')

    // Setting filtered and sorted state
    setFilteredInfo(Filters);     // Save filters for local state tracking
    setSortedInfo(sorter);         // Save sorter state
    setFilters(prev => ({ ...prev, ...Filters }));

    const params = {
      filters: filters,
    };

    getAuditData({ ...filters, ...Filters }
    );
  };


  const clearFilters = () => {
    setFilters({
      id: '',
      createdAt: '',
      Location_Id: '',
      SubDepartmentID: '',
      ForemanSupId: '',
      TemplateUsed: '',
      EvaluatorId: null,
    });
    getAuditData({}); // Call API with default values
  };
  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };
  const setAgeSort = () => {
    setSortedInfo({
      order: 'descend',
      columnKey: 'age',
    });
  };


  const handleAddEvent = (event) => {
    history.push(event);
  };
  const getEmployeeData = async () => {
    let result = await get_employee_listing_not_Terminated()
    if (result?.httpStatus === 200) {
      const data = result?.data.map((item, index) => {
        return {
          label: `${item?.firstName} ${item?.lastName}`,
          value: item?.id
        }
      })
      setEmployeeListData(data)
    }
  }

  const handleViewClick = async (eventId) => {
    try {

      const response = await get_AuditView({ id: eventId }); // Fetch data from the API
      console.log(response, 'API Response');

      if (response?.httpStatus === 200) {
        history.push('/AuditView', { id: eventId, data: response?.data, activeKey: 4 });
      } else {
        console.error('Failed to fetch data for the selected event.');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  function blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }
  const handleDownloadPdf = async (eventId) => {
    try {
      const response = await downlaod_pdf({ id: eventId }); // Correcting the function name
      const blob = new Blob([response], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Audit Report - ${eventId}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error exporting data:', error);
    }

  };
  function serializeParams(obj) {
    return Object.keys(obj)
      .filter(key => obj[key] !== null && obj[key] !== undefined && obj[key] !== '')
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
      .join('&');
  }
  const exportLocomotiveSheet = async () => {
    const queryString = '?' + serializeParams(filters).replace(/&&+/g, '&');
    const result = await exportAuditTab({ params: queryString });
    const blob = new Blob([result], { type: 'text/csv' });
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = 'AuditReport.csv';
    link.click();
    window.URL.revokeObjectURL(blobUrl);
  };
  const getUniqueAuditTypes = (rows) => {
    const auditTypeMap = new Map();
    rows.forEach(row => {
      if (row?.auditTypeId && row?.auditType) {
        auditTypeMap.set(row?.auditTypeId, { id: row.auditTypeId, name: row.auditType });
      }
    });
    return Array.from(auditTypeMap.values()); // Convert Set to Array
  };

  const getUniqueLocations = (rows) => {
    const locationsMap = new Map();
    rows.forEach(row => {
      if (row?.LocationId && row?.location) {
        locationsMap.set(row.LocationId, { id: row.LocationId, name: row.location });
      }
    });
    return Array.from(locationsMap.values()); // Convert Map to Array to get unique objects
  };
  const getUniqueForemen = (rows) => {
    const foremenMap = new Map();
    rows.forEach(row => {
      if (row?.foremanId && row?.foreman) {
        foremenMap.set(row?.foremanId, { id: row?.foremanId, name: row.foreman });
      }
    });
    return Array.from(foremenMap.values()); // Convert Map to Array to get unique objects
  };




  const getUniqueEventIds = (rows) => {
    const eventIdsMap = new Map();
    rows.forEach(row => {
      if (row.eventId) {
        eventIdsMap.set(row?.eventId, { id: row?.eventId, name: row.eventId });

      }
    });
    return Array.from(eventIdsMap.values()); // Convert Set to Array
  };

  const getUniqueSubDepartments = (rows) => {
    const SubDepartmentMap = new Map();
    rows.forEach(row => {
      if (row.subDepId) {
        SubDepartmentMap.set(row?.subDepId, { id: row?.subDepId, name: row.subDepartment });
      }
    });
    return Array.from(SubDepartmentMap.values()); // Convert Set to Array
  };


  const generateFilters = (uniqueValues) => {
    return uniqueValues.map(value => ({
      text: value.name, // Display the location name
      value: value.id,   // Send the location id
    }));
  };


  const columns = [

    {
      title: 'Event ID',
      dataIndex: 'eventId',
      key: 'id', // Corrected key
      width: '120px',

      filters: generateFilters(getUniqueEventIds(AuditTabData.rows)), // Dynamic filters
      filteredValue: filteredInfo.eventId || null, // Dynamically using eventId filter
      onFilter: (value, record) => record.eventId.toString().includes(value), // Filtering by eventId
      ellipsis: true,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div style={{ padding: 8, maxHeight: 200, overflowY: 'auto' }}>
          {generateFilters(getUniqueEventIds(AuditTabData.rows)).map(filter => (
            <div key={filter.value}>
              <Checkbox
                checked={selectedKeys.includes(filter.value)}
                onChange={(e) => {
                  const checked = e.target.checked;
                  const newKeys = checked
                    ? [...selectedKeys, filter.value]
                    : selectedKeys.filter(key => key !== filter.value);
                  setSelectedKeys(newKeys);
                }}
              >
                {filter.text}
              </Checkbox>
            </div>
          ))}
          <Button
            type="primary"
            onClick={() => confirm()} // Confirm the filter
            size="small"
            style={{ marginTop: 8, width: '100%', background: '#2963ad!important' }}
          >
            Filter
          </Button>
        </div>
      ),
    },

    {
      title: 'Date',
      dataIndex: 'date',
      key: 'createdAt',
      render: (_, record) => moment(record.date).format('MM-DD-YYYY'), // Display formatted date
      filteredValue: filteredInfo.date || null,
      onFilter: (value, record) => {
        if (!value) return true; // If no date, show all records
        const recordDate = moment.utc(record.date); // Ensure UTC handling
        const selectedDate = moment.utc(value); // Ensure selected date is UTC
        return recordDate.isSame(selectedDate, 'day'); // Filter records by exact date match
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <DatePicker
            value={selectedKeys[0] || null}
            onChange={(createdAt) => setSelectedKeys([createdAt])}
            style={{ width: 188 }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => {
                confirm();
                setFilters(prev => ({ ...prev, createdAt: selectedKeys[0] }))
              }}
            >
              Filter
            </Button>
          </Space>
        </div>
      ),
      ellipsis: true,
    },
    {
      title: 'Time',
      dataIndex: 'time',
      key: 'time',
      width: '70px',


      filteredValue: filteredInfo.name || null,
      onFilter: (value, record) => record.name.includes(value),
      ellipsis: true,
    },
    {
      title: 'Location',
      dataIndex: 'location',
      key: 'Location_Id',
      width: '250px',

      filters: generateFilters(getUniqueLocations(AuditTabData.rows)), // Dynamic filters
      filteredValue: filteredInfo.LocationId || null, // Dynamically using LocationId filter
      onFilter: (value, record) => record.LocationId.toString().includes(value), // Filtering by LocationId
      ellipsis: true,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div style={{ padding: 8 }}>
          {generateFilters(getUniqueLocations(AuditTabData.rows)).map(filter => (
            <div key={filter.value}>
              <Checkbox
                checked={selectedKeys.includes(filter.value)}
                onChange={(e) => {
                  const checked = e.target.checked;
                  const newKeys = checked
                    ? [...selectedKeys, filter.value]
                    : selectedKeys.filter(key => key !== filter.value);
                  setSelectedKeys(newKeys); // Update the selected keys
                }}
              >
                {filter.text}
              </Checkbox>
            </div>
          ))}
          <Button
            type="primary"
            onClick={() => confirm()} // Confirm the filter
            size="small"
            style={{ marginTop: 8, width: '100%', background: '#2963ad !important' }}
          >
            Filter
          </Button>
        </div>
      ),
    },
    {
      title: 'Sub Department',
      dataIndex: 'subDepartment',
      key: 'SubDepartmentID',
      width: '200px',

      filters: generateFilters(getUniqueSubDepartments(AuditTabData.rows)), // Dynamic filters
      filteredValue: filteredInfo.subDepId || null, // Dynamically using subDepId filter
      onFilter: (value, record) => record?.subDepId.toString().includes(value), // Filtering by subDepId
      ellipsis: true,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div style={{ padding: 8 }}>
          {generateFilters(getUniqueSubDepartments(AuditTabData.rows))?.map(filter => (
            filter?.value !== 'N/A' &&
            <div key={filter.value}>
              <Checkbox
                checked={selectedKeys.includes(filter.value)}
                onChange={(e) => {
                  const checked = e.target.checked;
                  const newKeys = checked
                    ? [...selectedKeys, filter.value]
                    : selectedKeys.filter(key => key !== filter.value);
                  setSelectedKeys(newKeys); // Update selected keys
                }}
              >
                {filter.text}
              </Checkbox>
            </div>
          ))}
          <Button
            type="primary"
            onClick={() => confirm()} // Confirm the filter
            size="small"
            style={{ marginTop: 8, width: '100%', background: '#2963ad !important' }}
          >
            Filter
          </Button>
        </div>
      ),
    },
    {
      title: 'Foreman',
      dataIndex: 'foreman',
      key: 'ForemanSupId',
      width: '150px',

      filters: generateFilters(getUniqueForemen(AuditTabData.rows)), // Dynamic filters
      filteredValue: filteredInfo.foremanId || null, // Dynamically using foremanId filter
      onFilter: (value, record) => record?.foremanId.toString().includes(value), // Filtering by foremanId
      ellipsis: true,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div style={{ padding: 8 }}>
          {generateFilters(getUniqueForemen(AuditTabData.rows)).map(filter => (
            <div key={filter.value}>
              <Checkbox
                checked={selectedKeys.includes(filter.value)}
                onChange={(e) => {
                  const checked = e.target.checked;
                  const newKeys = checked
                    ? [...selectedKeys, filter.value]
                    : selectedKeys.filter(key => key !== filter.value);
                  setSelectedKeys(newKeys); // Update selected keys
                }}
              >
                {filter.text}
              </Checkbox>
            </div>
          ))}
          <Button
            type="primary"
            onClick={() => confirm()} // Confirm the filter
            size="small"
            style={{ marginTop: 8, width: '100%', background: '#2963ad !important' }}
          >
            Filter
          </Button>
        </div>
      ),
    },


    {
      title: 'Audit Type',
      dataIndex: 'auditType',
      key: 'TemplateUsed',
      width: '150px',

      filters: generateFilters(getUniqueAuditTypes(AuditTabData.rows)), // Filter dynamic filter
      filteredValue: filteredInfo.auditTypeId || null, // Dynamically using auditTypeId filter
      onFilter: (value, record) => record.auditTypeId.toString().includes(value), // Filtering by auditTypeId
      ellipsis: true,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div style={{ padding: 8 }}>
          {generateFilters(getUniqueAuditTypes(AuditTabData.rows)).map(filter => (
            <div key={filter.value}>
              <Checkbox
                checked={selectedKeys.includes(filter.value)}
                onChange={(e) => {
                  const checked = e.target.checked;
                  const newKeys = checked
                    ? [...selectedKeys, filter.value]
                    : selectedKeys.filter(key => key !== filter.value);
                  setSelectedKeys(newKeys); // Update selected keys
                }}
              >
                {filter.text}
              </Checkbox>
            </div>
          ))}
          <Button
            type="primary"
            onClick={() => confirm()} // Confirm the filter
            size="small"
            style={{ marginTop: 8, width: '100%', background: '#2963ad !important' }}
          >
            Filter
          </Button>
        </div>
      ),
    },


    {
      title: 'View',
      dataIndex: 'view',
      width: '6%',
      render: (text, record) => (
        <Button onClick={() => handleViewClick(record.eventId)} className="ViewIcon"> </Button>
      ),
    },
    {
      title: 'Export',
      dataIndex: 'export',

      render: (text, record) => (
        <UploadOutlined style={{ background: "#2963AD", borderRadius: "100%", padding: "9px", color: 'white' }}
          onClick={() => handleDownloadPdf(record.eventId)}
        />
      ),
    },

  ];


  const handleEvaluatorChange = async (selectedValue) => {
    // setFilters(prev => ({ ...prev, EvaluatorId: value })); // Update filter state
    setFilters((prevFilters) => ({
      ...prevFilters,
      EvaluatorId: selectedValue,
    }));
    try {
      const res = await getAllData(`?EvaluatorId=${selectedValue}`);

      if (res?.code === "000000" && res?.data?.length > 0) {
        const rows = res.data.map((row) => ({
          key: row?.id,
          eventId: row?.id.toString(),
          date: moment(row?.AuditDate)?.format('MM-DD-YYYY'),
          time: row?.AuditTime ? row?.AuditTime.substring(0, 5) : "N/A",
          location: row?.TGSLocation?.name || "N/A",
          LocationId: row?.TGSLocation?.id,
          subDepartment: row?.SubDepartment?.name || "N/A",
          subDepId: row?.SubDepartmentID || "N/A",
          foreman: `${row?.Supervisor?.firstName || ""} ${row?.Supervisor?.lastName || ""}`.trim() || "N/A",
          foremanId: row?.Supervisor?.id || "N/A",
          auditType: row?.TestingAudit_Template?.name || "N/A",
          auditTypeId: row?.TestingAudit_Template?.id || "N/A",
          export: <UploadOutlined style={{ background: "#2963AD", borderRadius: "100%", padding: "9px", color: 'white' }} />
        }));

        setAuditTabData({
          header: columns,
          rows,
        });




      } else {
        setAuditTabData({
          header: [{ title: "No Data", dataIndex: "noData", key: "noData" }],
          rows: [],
        });
      }
    } catch (error) {
      console.error("Error fetching audit data:", error);
    }
  };
  const getAuditData = async (params) => {
    try {

      const res = await getAllData(params);

      if (res?.code === "000000" && res?.data?.length > 0) {
        const rows = res.data.map((row) => ({
          key: row?.id,
          eventId: row?.id.toString(), // Ensure eventId is string for filtering
          date: moment(row?.AuditDate)?.format('MM-DD-YYYY'),
          time: row?.AuditTime ? row?.AuditTime.substring(0, 5) : "N/A",
          location: row?.TGSLocation?.name || "N/A",
          LocationId: row?.TGSLocation?.id,
          subDepartment: row?.SubDepartment?.name || "N/A",
          subDepId: row?.SubDepartmentID || "N/A",
          foreman: `${row?.Supervisor?.firstName || ""} ${row?.Supervisor?.lastName || ""}`.trim() || "N/A",
          foremanId: row?.Supervisor?.id || "N/A",
          auditType: row?.TestingAudit_Template?.name || "N/A",
          auditTypeId: row?.TestingAudit_Template?.id || "N/A",
          export: <UploadOutlined style={{ background: "#2963AD", borderRadius: "100%", padding: "9px", color: 'white' }} />
        }));


        setAuditTabData({
          header: columns,
          rows,
        });



      } else {
        setAuditTabData({
          header: [{ title: "No Data", dataIndex: "noData", key: "noData" }],
          rows: [],
        });
      }
    } catch (error) {
      console.error("Error fetching audit data:", error);
    }
  };
  useEffect(() => {
    getEmployeeData();
    getAuditData()

  }, []);
  // useEffect(() => {
  //   getAuditData()`
  // }, [filters]);

  return (
    <>
      <div>

        <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            {roleManager("safetyTesting", "EnterAudit") &&
              <Button
                onClick={handleAddEvent.bind(null, 'enter-audit', 2)}
                style={{ background: '#2963AD ', color: 'white', height: '50px', borderRadius: '10px' }}>
                Enter Audit
              </Button>
            }
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '10px' }}>

            <Button style={{ background: '#2963AD', color: 'white', height: '32px' }}
              onClick={clearFilters}>Reset Filter</Button>
            {roleManager("safetyTesting", "EnterAuditEvaluator") &&

              <Select
                style={{ width: "200px", marginBottom: '' }}
                showSearch
                optionFilterProp="children"
                onChange={handleEvaluatorChange}
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                placeholder={`Select Auditor`}
                options={EmployeeListData}
                value={filters?.EvaluatorId}
              />
            }

            <Button
              style={{ background: '#2963AD', color: 'white', height: '32px' }}
              onClick={() => {
                exportLocomotiveSheet()
              }}
            >
              {loading ? <CircularProgress size={24} /> : 'Export List'}
            </Button>
          </div>
        </div>
      </div>

      <Table
        columns={columns}
        dataSource={AuditTabData.rows}
        size="middle"
        scroll={{ x: 1200 }}
        onChange={handleChange}

      />

    </>
  );
};
export default AuditTab;